export default __webpack_public_path__ + "static/media/letter.868f83eb.png";